import {isNil} from '../../helpers'
import {getStringSha256Hash} from "../../../../../../hb180-bauwerk/Resources/Private/Scripts/helpers";

export default class Overlay {
    /**
     *
     * @param {HTMLElement} _root Content of overlay
     * @param {string} _triggerSelector selector string for trigger buttons
     * @param {string} _identifier name identifier for the overlay
     * @param {HTMLElement} _focusedElement element that should be focused inside the overlay
     */
    constructor(_root, _triggerSelector, _identifier, _focusedElement) {
        this._root = _root
        this._focusedElement = _focusedElement
        this._identifier = _identifier
        this._trigger = document.querySelectorAll(_triggerSelector)
        this._overlayContainer = null;
        this._overlayContent = null;
        this._closeButton = null
        this._createOverlayContainer()
        this._setupEventListeners()
    }

    _setupEventListeners() {
        this._trigger.forEach(_trigger => {
            _trigger.addEventListener('click', this._open.bind(this), true);
        })
        this._closeButton.addEventListener('click', this._close.bind(this), true);
    }

    _createOverlayContainer() {
        const overlayElement = document.createElement('div');
        overlayElement.classList.add('overlay');
        overlayElement.classList.add(`overlay-${this._identifier}`);

        const closeButton = document.createElement('button');
        closeButton.classList.add('overlay__close');
        const closeButtonContent = document.createElement('span');
        closeButtonContent.classList.add('icon');
        closeButtonContent.classList.add('icon--close');
        closeButton.appendChild(closeButtonContent);

        const overlayInnerElement = document.createElement('div');
        overlayInnerElement.classList.add('overlay__content');

        overlayElement.appendChild(closeButton);
        overlayElement.appendChild(overlayInnerElement);
        document.body.appendChild(overlayElement);

        this._overlayContainer = overlayElement;
        this._overlayContent = overlayInnerElement;
        this._closeButton = closeButton;
    }

    _open() {
        this._overlayContainer.classList.add('overlay--open');
        this._overlayContainer.setAttribute('role', 'dialog');
        this._overlayContent.append(this._root);
        document.body.classList.toggle('noscroll');

        if (window.getComputedStyle(this._root)['display'] === 'none') {
            this._root.style.display = 'block';
        }

        if (!isNil(this._focusedElement)) {
            this._focusedElement.focus();
        }

        document.addEventListener('keyup', this._onKeyPress.bind(this), true)
    }

    _close() {
        this._overlayContainer.classList.remove('overlay--open');
        document.body.classList.remove('noscroll');
    }

    _onKeyPress(_event) {
        if (_event.key === 'Escape') {
            this._close();
        }
    }
}



// WEBPACK FOOTER //
// ./Private/Scripts/components/overlay/Overlay.js